<template>
  <v-container>
    <v-layout row wrap>
      <v-flex sm12 class="my-3">
        <h1>Modify Portfolios</h1>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex sm12 class="my-3">
        <v-card>
          <v-toolbar color="cyan" dark>
            <v-toolbar-side-icon></v-toolbar-side-icon>

            <v-toolbar-title>Portfolios</v-toolbar-title>

            <v-spacer></v-spacer>
            <!-- Add Portfolio Form Dialog Box -->
                <v-dialog v-model="dialog" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                    <v-btn color="error"
                    v-on="on"
                    @click="lauchNewDialog"
                    >
                      Add Portfolio
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                    <span class="headline">Portfolio</span>
                    </v-card-title>
                    <v-card-text>
                        <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                        >
                        <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field
                                v-model="form.title"
                                :counter="60"
                                :rules="titleRules"
                                label="Title*"
                                required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                            <v-text-field
                                v-model="form.description"
                                :rules="descriptionRules"
                                label="Description*"
                            ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-autocomplete
                                  v-model="form.projects"
                                  :items="projects"
                                  box
                                  chips
                                  color="blue-grey lighten-2"
                                  label="Select"
                                  multiple
                                  item-text="title"
                                  item-value="title"
                                  return-object
                                >
                                <template v-slot:selection="data">
                                    <v-chip
                                    :selected="data.selected"
                                    close
                                    class="chip--select-multi"
                                    @input="data.parent.selectItem(data.item)"
                                    >
                                      {{ data.item.title }}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                    </template>
                                    <template v-else>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="data.item.title"></v-list-tile-title>
                                    </v-list-tile-content>
                                    </template>
                                </template>
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>
                        </v-container>
                        </v-form>
                        <small>indicates required field</small>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                        color="blue darken-1"
                        flat
                        @click="dismissDialog"
                        >
                          Close
                        </v-btn>
                        <v-btn
                        color="blue darken-1"
                        flat
                        :disabled="!valid"
                        @click="validate"
                        >Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
          </v-toolbar>

          <v-list two-line>
            <template v-for="portfolio in portfolios">
              <v-list-tile
                :key="portfolio.title"
              >
                <v-list-tile-avatar color="teal">
                    <span class="white--text headline">
                      {{ portfolio.projects.length }}
                    </span>
                </v-list-tile-avatar>

                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-list-tile-content>
                          <v-list-tile-title v-html="portfolio.title"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="portfolio.description"></v-list-tile-sub-title>
                        </v-list-tile-content>

                      </span>
                  </template>
                  <span>
                      <ul id="projects">
                          <li
                          v-for="project in portfolio.projects"
                          :key="project.title"
                          >
                              {{ project.title }}
                          </li>
                      </ul>
                  </span>
                </v-tooltip>
                <v-spacer></v-spacer>

                  <div class="text-xs-center">
                  <v-btn icon ripple color="blue lighten-1" @click="onEdit(portfolio)">
                    <v-icon color="white">edit</v-icon>
                  </v-btn>
                  <v-btn icon ripple color="red lighten-1">
                    <v-icon color="white" @click="deletePortfolio(portfolio)">delete</v-icon>
                  </v-btn>
                  </div>
              </v-list-tile>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { db, CurrentTime } from '@/db.js'

export default {
  name: 'portfolio',
  data () {
    return {
      portfolios: [],
      projects: [],
      dialog: false,
      valid: true,
      form: {
        title: '',
        description: '',
        projects: [],
        uri: ''
      },
      titleRules: [
        v => !!v || 'Title is required',
        v => (v && v.length <= 60) || 'Title must be less than 60 characters'
      ],
      descriptionRules: [
        v => !!v || 'Description is required'
      ]
    }
  },
  methods: {
    triggerSnackbar (text) {
      this.$store.dispatch('setsnackbarOptions', {
        text: text
      })
    },
    launchDialog () {
      this.dialog = true
    },
    dismissDialog () {
      this.dialog = false
    },
    reset () {
      this.$refs.form.reset()
    },
    deletePortfolio (portfolio) {
      db
        .collection('portfolios')
        .doc(portfolio.uri)
        .delete()
        .then(() => {
          vm.triggerSnackbar('Successful write to database')
        })
        .catch((error) => {
          vm.triggerSnackbar('Failed to update to database:' + error)
          throw new Error(error)
        })
    },
    lauchNewDialog () {
      this.reset()
      this.launchDialog()
    },
    remove (item) {
      const index = this.form.projects.indexOf(item.title)
      if (index >= 0) this.form.projects.splice(index, 1)
    },
    validate () {
      if (this.$refs.form.validate()) {
        this.dismissDialog()
        this.sendForm()
      }
    },
    onEdit (portfolio) {
      this.form = portfolio
      this.launchDialog()
    },
    sendForm () {
      let formPayload = _.cloneDeep(this.form)

      formPayload.uri = encodeURIComponent(
        _.camelCase(formPayload.title)
      )

      if (formPayload.createdAt) {
        formPayload.createdAt = CurrentTime
      }
      formPayload.editedAt = CurrentTime

      var projects = []
      formPayload.projects.forEach(element => {
        projects.push(db.doc('projects/' + element.uri))
      })
      formPayload.projects = projects

      this.sendFormPayload(formPayload)
    },
    sendFormPayload (formPayload) {
      let vm = this

      db
        .collection('portfolios')
        .doc(formPayload.uri)
        .set(
          formPayload,
          {
            merge: true
          })
        .then(() => {
          vm.triggerSnackbar('Successful write to database')
        })
        .catch((error) => {
          vm.triggerSnackbar('Failed to update to database:' + error)
          throw new Error(error)
        })
    }
  },
  firestore: {
    portfolios: db.collection('portfolios'),
    projects: db.collection('projects')
  }
}
</script>
